import { render, staticRenderFns } from "./HomePickuplist.vue?vue&type=template&id=f0ccc388&scoped=true&"
import script from "./HomePickuplist.vue?vue&type=script&lang=ts&"
export * from "./HomePickuplist.vue?vue&type=script&lang=ts&"
import style0 from "./HomePickuplist.vue?vue&type=style&index=0&id=f0ccc388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ccc388",
  null
  
)

export default component.exports